import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete, AiOutlineClose } from "react-icons/ai";

const Invoices = () => {
    const [invoices, setInvoices] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [selectedInvoice, setSelectedInvoice] = useState(null);

    useEffect(() => {
        (async () => {
            const { data } = await axios.get(`invoice?page=${page}`);
            setInvoices(data.data || []);
            setLastPage(data.meta?.last_page || 1);
        })();
    }, [page]);

    const del = async (id) => {
        if (window.confirm("Are you sure you want to delete this record?")) {
            await axios.delete(`invoices/${id}`);
            setInvoices(invoices.filter((i) => i.id !== id));
        }
    };

    return (
        <Wrapper pageTitle="Invoices">
            <InnerNav createLink="/invoiceCreate" listLink="/invoices" />

            <div className="w-full overflow-hidden rounded-lg shadow">
                <div className="w-full overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="bg-gray-100 text-gray-600 uppercase">
                            <tr>
                                <th className="px-4 py-3">#</th>
                                <th className="px-4 py-3">Invoice No</th>
                                <th className="px-4 py-3">Client</th>
                                <th className="px-4 py-3">Invoice Date</th>
                                <th className="px-4 py-3 text-right">Total</th>
                                <th className="px-4 py-3">Action</th>
                            </tr>
                        </thead>

                        <tbody className="divide-y">
                            {invoices.length > 0 ? (
                                invoices.map((invoice) => (
                                    <tr
                                        key={invoice.id}
                                        className="hover:bg-gray-50 cursor-pointer"
                                        onClick={() => setSelectedInvoice(invoice)}
                                    >
                                        <td className="px-4 py-3">{invoice.id}</td>
                                        <td className="px-4 py-3 font-medium">
                                            {invoice.invoice_no}
                                        </td>
                                        <td className="px-4 py-3">
                                            {invoice.client?.name}
                                        </td>
                                        <td className="px-4 py-3">
                                            {invoice.invoice_date}
                                        </td>
                                        <td className="px-4 py-3 text-right">
                                            KES {Number(invoice.invoice_total).toLocaleString()}
                                        </td>
                                        <td
                                            className="px-4 py-3 flex gap-2"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <Link
                                                to={`/invoice/${invoice.id}/edit`}
                                                className="text-blue-600"
                                            >
                                                <AiFillEdit />
                                            </Link>
                                            <button
                                                onClick={() => del(invoice.id)}
                                                className="text-red-600"
                                            >
                                                <AiFillDelete />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan="6"
                                        className="text-center py-6 text-gray-500"
                                    >
                                        No invoices found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <Paginator lastPage={lastPage} pageChanged={setPage} />
            </div>

            {/* MODAL */}
            {selectedInvoice && (
                <InvoiceModal
                    invoice={selectedInvoice}
                    onClose={() => setSelectedInvoice(null)}
                />
            )}
        </Wrapper>
    );
};

export default Invoices;


const InvoiceModal = ({ invoice, onClose }) => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg w-full max-w-2xl p-6 relative">
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-500 hover:text-black"
                >
                    <AiOutlineClose size={20} />
                </button>

                <h2 className="text-xl font-bold mb-4">
                    Invoice #{invoice.invoice_no}
                </h2>

                <div className="grid grid-cols-2 gap-4 text-sm mb-6">
                    <div>
                        <p className="font-semibold">Client</p>
                        <p>{invoice.client?.name}</p>
                        <p>{invoice.client?.email}</p>
                        <p>{invoice.client?.contact_phone}</p>
                    </div>

                    <div>
                        <p className="font-semibold">Invoice Details</p>
                        <p>Date: {invoice.invoice_date}</p>
                        <p className="font-bold text-green-700">
                            Total: KES {Number(invoice.invoice_total).toLocaleString()}
                        </p>
                    </div>
                </div>

                <div className="border-t pt-4">
                    <p className="font-semibold mb-2">Travel Package</p>
                    <p>{invoice.travel_package?.name}</p>
                    <p className="text-gray-600 text-sm">
                        {invoice.travel_package?.date_range}
                    </p>
                    <p className="mt-1">
                        Package Cost: KES{" "}
                        {Number(invoice.travel_package?.total_cost).toLocaleString()}
                    </p>
                </div>
            </div>
        </div>
    );
};
